var classes = {
  "tooltip": "tooltip__PCgft",
  "wrapper": "wrapper__MOPaB",
  "danger": "danger__qiCS4",
  "primary": "primary__p-jNd",
  "xxsmall": "xxsmall__BgrEX",
  "xsmall": "xsmall__Nhxqb",
  "small": "small__h-AFh",
  "medium": "medium__F7EdR",
  "large": "large__ShssO",
  "xlarge": "xlarge__qbPx5",
  "xxlarge": "xxlarge__HI8Bv"
};
export { classes as default };